import React, { useCallback, useEffect, useRef, useState } from 'react';
import LocalOpsSheet from './LocalOpsSheet';
import { formatJGK, getLocalOpsConfig } from '../../utils/localOpsConfig';
import { COLLISION_SPECIALIST_RIDE_TEMPLATE } from '../../utils/localOpsCollisionSpecialistRide';
import BuyJGKToken from '../buyJGKToken/BuyJGKToken';

export default function LocalOpsTopUpSheet({
  open,
  onClose,
  presetAmount,
  returnTo,
  onCheckoutStart,
  variant = null,
  requiredTopUpJGK = null,
}) {
  const { jgkPerUsd } = getLocalOpsConfig();
  const rate = Number.isFinite(jgkPerUsd) ? jgkPerUsd : 1000;
  const rateLabel = formatJGK(rate);
  const checkoutCloseRef = useRef(false);
  const [checkoutStarting, setCheckoutStarting] = useState(false);
  const isCollisionSpecialistRide =
    variant === COLLISION_SPECIALIST_RIDE_TEMPLATE;
  const parsedRequiredTopUpJGK = Number(requiredTopUpJGK);
  const safeRequiredTopUpJGK =
    Number.isFinite(parsedRequiredTopUpJGK) && parsedRequiredTopUpJGK > 0
      ? Math.round(parsedRequiredTopUpJGK)
      : null;
  const fundingContext =
    safeRequiredTopUpJGK
      ? {
          type: isCollisionSpecialistRide
            ? COLLISION_SPECIALIST_RIDE_TEMPLATE
            : 'localops_pending_funding',
          requiredTopUpJGK: safeRequiredTopUpJGK,
        }
      : null;

  useEffect(() => {
    if (open) {
      checkoutCloseRef.current = false;
      setCheckoutStarting(false);
    }
  }, [open]);

  const handleCheckout = useCallback(() => {
    if (checkoutCloseRef.current) return;
    checkoutCloseRef.current = true;
    setCheckoutStarting(true);
    onCheckoutStart?.();
    onClose?.();
  }, [onCheckoutStart, onClose]);

  return (
    <LocalOpsSheet
      open={open}
      onClose={onClose}
      title={isCollisionSpecialistRide ? 'Fund your ride request' : 'Top up JGK Balance'}
    >
      <div className="localops-section">
        <div className="localops-helper">
          {isCollisionSpecialistRide
            ? 'This adds JGK to your balance and uses it to fund this ride request.'
            : 'Add JGK to finish approving this task.'}
        </div>
        <div className="localops-helper">
          JGK Balance is prepaid credit you can earn or top up.
        </div>
        <div className="localops-helper">Current rate: {rateLabel} = $1</div>
        <div className="localops-helper">
          After topping up, you'll return here to approve and publish.
        </div>
        <div className="localops-helper">
          If payment closes or fails, you're still on this step. Try again.
        </div>
      </div>
      <div className="localops-topup-embed">
        <BuyJGKToken
          onCheckout={handleCheckout}
          presetAmount={presetAmount}
          returnTo={returnTo}
          fundingContext={fundingContext}
          checkoutLabel={checkoutStarting ? 'Opening Stripe...' : undefined}
        />
      </div>
      <div className="localops-actions">
        <button
          type="button"
          className="localops-btn localops-btn--ghost"
          onClick={onClose}
          disabled={checkoutStarting}
        >
          {checkoutStarting ? 'Opening Stripe...' : 'Return to confirmation'}
        </button>
      </div>
    </LocalOpsSheet>
  );
}
